import stickElement from '../components/stickit'
import 'jquery-drilldown'

export default {
  init() {
    function smooth_scroll(link, e) {
      if (e) e.preventDefault()
      var hash = false
      if (!link && window.location.hash) {
        hash = window.location.hash
      } else if (link && link.indexOf('#') == 0) {
        hash = link
      } else if (
        link &&
        location.pathname.replace(/^\//, '') ==
          link.pathname.replace(/^\//, '') &&
        location.hostname == link.hostname
      ) {
        hash = link.hash
      }
      if (hash && $(hash).length) {
        $('html, body').animate(
          {
            scrollTop: $(hash).offset().top - 120,
          },
          600
        )
        history.replaceState(null, null, hash)
      }
      $(window).trigger('hashchange')
    }

    $(window).load(function () {
      stickElement('.banner .navbar')
      stickElement('.page-anchors')

      /* eslint-disable */
      $(
        'a[href^="#"]:not([href="#"],[href="#0"],[href^="#fancy-"],[data-toggle],[role="tab"])'
      ).on('click tap', function (e) {
        smooth_scroll($(this).attr('href'), e)
      })
      /* eslint-enable */
    })

    $(document).bind('gform_post_render', function () {
      //
    })

    $('.banner [data-toggle="collapse"]').on('click', function () {
      $(this)
        .siblings('[data-toggle="collapse"][aria-expanded="true"]')
        .trigger('click')
    })

    // Menu dropdown on hover
    $('.nav-item.dropdown').on('mouseenter', function () {
      const $this = $(this)
      const $menu = $this.find('> .dropdown-menu')
      if (!$menu.hasClass('show') && !$('body').hasClass('mobile')) {
        $menu.addClass('show')
      }
    })
    $('.nav-item .nav-item:not(.dropdown)').on('mouseenter', function () {
      const $this = $(this)
      const $menu = $this.parent().find('.nav-item.dropdown > .dropdown-menu')
      if ($menu.hasClass('show') && !$('body').hasClass('mobile')) {
        $menu.removeClass('show')
      }
    })
    $('.navbar-nav > .nav-item.dropdown').on('mouseleave', function () {
      const $this = $(this)
      const $menu = $this.find('> .dropdown-menu')
      if ($menu.hasClass('show') && !$('body').hasClass('mobile')) {
        $menu.removeClass('show')
      }
    })
    $(
      '.navbar-nav > .nav-item.dropdown > .dropdown-menu > .nav-item.dropdown'
    ).on('mouseleave', function () {
      const $this = $(this)
      const $menu = $this.find('> .dropdown-menu')
      if ($menu.hasClass('show') && !$('body').hasClass('mobile')) {
        $menu.removeClass('show')
      }
    })
    $('.dropdown-menu').on('mouseleave', function () {
      const $this = $(this)
      $this.removeClass('show')

      $this.find('.dropdown-menu').removeClass('show')
    })
    $('.dropdown-toggle').on('click tap', function () {
      const $this = $(this)
      $this.next().toggleClass('show')
    })

    // DHSV
    init_lngBox()
    init_videobox()
    init_toggleSearchbar()
    init_footerDropdowns()

    function init_lngBox() {
      $('.topbar__languages .lng__head').on('click tap', function () {
        var e = $(this)
        var parent = e.parent()

        if (parent.hasClass('active')) {
          parent.removeClass('active')
        } else {
          parent.addClass('active')
        }
      })

      $(document).on('mouseup touchend', function (e) {
        const $head = $('.topbar__languages .lng__head')
        if (!$head.is(e.target) && $head.has(e.target).length === 0) {
          $head.parent().removeClass('active')
        }
      })

      $('.topbar__languages .lng__body').on('mouseleave', function () {
        const $this = $(this)
        $this.parent().removeClass('active')
      })
    }

    function init_videobox() {
      const videobox = $('.videobox')
      const videoframe = videobox.find('.videowrapper .videocon iframe')

      $(document).on('mouseup touchend', function (e) {
        const videocon = $('.videobox.open .videowrapper .videocon')
        if (
          (!videocon.is(e.target) &&
            videocon.has(e.target).length === 0 &&
            videocon.find('iframe')[0]) ||
          videocon.find('span').is(e.target)
        ) {
          videobox.removeClass('open')
          videocon
            .find('iframe')[0]
            .contentWindow.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              '*'
            )
        }
      })

      $('[data-videoid]').on('click tap', function () {
        let $this = $(this)
        if ($this.data('videoid') !== videoframe.data('oldid')) {
          videobox.addClass('isLoading')
          videoframe.attr(
            'src',
            '//www.youtube-nocookie.com/embed/' +
              $this.data('videoid') +
              '?enablejsapi=1&amp;rel=0&amp;showinfo=0'
          )
          videoframe.data('oldid', $this.data('videoid'))
        }

        videobox.addClass('open')
      })

      $(videoframe).on('load', function () {
        videobox.removeClass('isLoading')
        videoframe[0].contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          '*'
        )
      })
    }

    function init_toggleSearchbar() {
      const $searchbar = $('#searchbar')
      $('.searchbar-toggler').on('click tap', function () {
        $searchbar.toggleClass('open')
      })

      $searchbar.find('i').on('click tap', function () {
        $searchbar.removeClass('open')
      })
    }

    function init_footerDropdowns() {
      $('.footer__main .footer__menu li.menu-item-has-children ul li > a').on(
        'click tap',
        function (e) {
          e.preventDefault()
          const $this = $(this)
          //const $li = $this.parent()
          var $menu = $this.next()

          if ($this.hasClass('active')) {
            $menu.animate(
              {
                height: 0,
              },
              400
            )
            $this.removeClass('active')
          } else {
            $menu.animate(
              {
                height: $menu.get(0).scrollHeight,
              },
              400,
              function () {
                $menu.height('auto')
              }
            )
            $this.addClass('active')
          }
        }
      )
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}
